// extracted by mini-css-extract-plugin
export default {"cls1":"SignupBanner-cls1_WPy","cls2":"SignupBanner-cls2__d3 SignupBanner-cls1_WPy"};